import Headshot from "../about/Headshot";

const aboutMe = (
  <>
    <div className="about-content top-left-align my-col">
      <Headshot />
      <p className="about-bio">
        If you needed living proof that it takes a village to raise a child,
        you’re looking right at her! Raised in both Los Angeles and Manila, I am
        a product of the unwavering love and compassion that my communities have
        shown me. I seek projects and experiences that allow me to apply my
        technical knowledge in promoting social and cultural enrichment. I hold
        inclusive design as one of my tenets in life, ensuring that all my work
        — whether in accessible web design or transparent data analysis —
        reflects such.
        <br />
        <br />
        While my bigger dreams are rooted in community empowerment, my other
        ones hinge on having some plain, old fun. I enjoy drinking bubble tea,
        cheering on the Lakers, outpacing my friends on NYT’s daily crosswords,
        cooking up Asian fusion recipes, and practicing my tennis serve.
        <br />
        <br />
        If you share my passion of innovating ways to use tech for social good,
        especially within Southeast Asian and Southeast Asian-American
        communities, I would absolutely love to chat! Please feel free to send
        an{" "}
        <a
          href="mailto:marielpacada08@gmail.com"
          target="_blank"
          rel="noreferrer"
        >
          email
        </a>
        !
      </p>
    </div>
  </>
);

export default aboutMe;
